import { useEffect } from "react";


export const Map = ({ coords }: MapProps) => {
    useEffect(() => {
        const defaultMapCenter = [55.751244, 37.618423]
        const map = new window.DG.map('map-container', {
            center: coords ?  [coords.Latitude, coords.Longitude] : defaultMapCenter,
            zoom: 13
        });

        const greenHtmlIcon = window.DG.divIcon({
            className: 'custom-html-icon', // Add a custom class to style the marker
            html: '<div class="green-marker"></div>', // HTML content of the marker
            iconSize: [16, 16], // Size of the marker
            iconAnchor: [16, 16], // Anchor of the marker
            popupAnchor: [0, 0], // Popup anchor point
        });

        // Example: Adding a marker to the map
        if (coords) {
            window.DG.marker([coords.Latitude, coords.Longitude], { icon: greenHtmlIcon }).addTo(map).bindPopup('This is Location 🔋!');
        }
        
    }, [coords]);

    return (<div id="map-container" style={{ width: '100%', height: '500px' }}/>);
};